import { all } from 'redux-saga/effects'

import { createSaga } from './create/saga'
import { editSaga } from './edit/sagas'
import { removeSaga } from './remove/saga'
import { entriesSaga } from './entries/sagas'

export function* immigrateQuestionSaga() {
  yield all([createSaga(), editSaga(), removeSaga(), entriesSaga()])
}
